import { Link } from "react-router-dom";
import { FaUser, FaHeart, FaComment } from "react-icons/fa";

export default function Notification({ notification }) {
  const { from, to, type, read } = notification

  return (
    <div className='border-bottom border-secondary'>
	  <div className='d-flex align-items-center gap-2 p-4'>
	    {type === "follow" && <FaUser className='fs-5 text-primary' />}
		{type === "like" && <FaHeart className='fs-5 text-danger' />}
		{type === "comment" && <FaComment className='fs-5 text-success' />}

		<Link to={`/users/${from.id}`} className='text-decoration-none'>
		  <div className='avatar'>
			<div className='w-8 rounded-circle'>
			  <img 
				src={from.profileImg || "/avatar-placeholder.png"}
				className="rounded-circle"
				style={{ width: '50px', height: '50px' }}
				alt="Profile"
			  />
			</div>
		  </div>
		
		  <div className={`d-flex align-items-center rfs-5 ${type === 'like' ? 'text-danger' : ( type === 'follow' ? 'text-info' : 'text-success' )}`}>
		    <span className='fw-bold'>@{from.username}</span>&nbsp;
			<span>{' '}</span>
            {type === "follow" && " followed you"}
			{type === "like" && " liked your post"}
			{type === "comment" && " commented on your post"}
		  </div>
		</Link>
	  </div>
	</div>
  )
}